import React from "react";
import "./events.css";
import EventImg from "../../Assets/events.PNG";

function Events() {
  return (
    <div className="events-container">
      <img src={EventImg} alt="event img" className="event-img" />
    </div>
  );
}

export default Events;
